export default __webpack_public_path__ + "static/media/icon-reorder.4a70070b.svg";